<p>Standard format requirements list</p>

<mat-radio-group>
  <mat-radio-button *ngFor="let type of standardFormatTypes" [value]="type" (change)="selectOption(type)">
    <span class="radio-button-label">
      {{ type | standardFormatTypeDisplayName }}
    </span>
  </mat-radio-button>
</mat-radio-group>
